/** Start Header & Footer Script **/

$(window).scroll(function () {
  var sticky = $(".sticky1"),
    scroll = $(window).scrollTop();

  if (scroll >= 150) sticky.addClass("fixed");
  else sticky.removeClass("fixed");
});
$(".mobile_btn").on("click", function () {
  $(".main_menu").toggleClass("active");
  $(".mobile_btn").toggleClass("active");
  $(".main_menu.active.nav__item").toggle();
});
$(function ($) {
  $(" .mobile_title_2").on("click", function () {
    $(this)
      .parent("  .has_dropdown")
      .children(" .sub_menu")
      .stop()
      .slideToggle();
  });
});
$(document).ready(function ($) {
  $(".has_dropdown_2")
    .find(".sub_menu_2_title")
    .click(function () {
      var isActive = $(this).hasClass("active");
      $(".sub_menu_2_title").removeClass("active");
      if (!isActive) {
        $(this).toggleClass("active");
      }
      $(this).next().slideToggle("fast");
      $(".sub_menu_2").not($(this).next()).slideUp("fast");
    });
});
$(" .sub__close").click(function (e) {
  e.preventDefault();
  $(this).parent().parent().removeClass("is-active");
});
// Trigger sub menu
$(" .nav__link").click(function (e) {
  //e.preventDefault();
  var currentTitle = $(this).text();
  $(".nav__link.sub__close").html(currentTitle);
  $(this).siblings().addClass("is-active");
});
$("#mobileButton").click(function () {
  $(".nav__sub.mobile_view").removeClass("is-active");
});

$("a.sub_menu_2_title").hover(function () {
  var contentAsset = $(this).attr("data-product");
  $(".product-img").hide();
  $('[alt="' + contentAsset + '"]').show();
});

$(".main_menu .main_menu_list li .sub_menu_2 a").hover(function () {
  var contentAsset = $(this).attr("data-product");
  console.log(contentAsset);
  $(".product-img").hide();
  $('[alt="' + contentAsset + '"]').show();
});

$(document).ready(function ($) {
  $(".footer_sub_col")
    .find(".footer_title")
    .click(function () {
      //Expand or collapse this panel
      var isActive = $(this).hasClass("active");
      $(".footer_title").removeClass("active");
      if (!isActive) {
        $(this).toggleClass("active");
      }

      $(this).next().slideToggle("fast");
      //Hide the other panels
      $(".footer_mb").not($(this).next()).slideUp("fast");
    });
});

var slides = document.querySelectorAll("#slides .slide");
var currentSlide = 0;
var slideInterval = setInterval(nextSlide, 5000);

function nextSlide() {
  slides[currentSlide].className = "slide";
  currentSlide = (currentSlide + 1) % slides.length;
  slides[currentSlide].className = "slide showing";
}
setTimeout(function () {
  $("span.money").text(function (i, text) {
    return text.replace("Dhs.", "");
  });
  $("span.money").text(function (i, text) {
    return text.replace("$", "");
  });
}, 200);

$(".promo-banner").on("click", ".promo-banner__close", () => {
  $("body").removeClass("promo-banner--show");
});

/** End Header & Footer Script **/


window.slideshow = {
  init() {
    $('.js-homepage-slideshow').each(function () {
      const $homepageSlider = $(this);
      const settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed') * 1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height'),
      };

      // Initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')) {
        const arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
          adaptiveHeight: settings.adaptiveHeight,
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          autoPlay: settings.slideshowSpeed
        });

        if (settings.slideshowTextAnimation !== '') {
          const flkty = $homepageSlider.data('flickity');
          setTimeout(() => {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass(`animated ${settings.slideshowTextAnimation}`);
          }, 400);

          $homepageSlider.on('select.flickity', () => {
            if ($homepageSlider.is(':visible')) {
              const currentSlide = flkty.selectedIndex + 1;
              setTimeout(() => {
                $homepageSlider.find('.caption-content').removeClass(`animated ${settings.slideshowTextAnimation}`);
                $homepageSlider.find(`.gallery-cell:nth-child(${currentSlide}) .caption-content`).addClass(`animated ${settings.slideshowTextAnimation}`);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }
    });
  },
  unload($target) {
    const $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');
  },
};

window.slideshow.init();


// Add to Cart button click handler
        document.addEventListener('DOMContentLoaded', function() {
            const cartButtons = document.querySelectorAll('a.current-product');
            
            cartButtons.forEach(function(button) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Find and trigger the product-form__submit button
                    const submitButton = document.querySelector('.product-form__submit');
                    
                    if (submitButton) {
                        submitButton.click();
                    } else {
                        console.warn('Product form submit button not found');
                    }
                });
            });

            const cartButton = document.querySelectorAll('button.add-to-cart');
            
            cartButton.forEach(function(button) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Find and trigger the product-form__submit button
                    const submitButton = document.querySelector('.product-form__submit');
                    
                    if (submitButton) {
                        submitButton.click();
                    } else {
                        console.warn('Product form submit button not found');
                    }
                });
            });

            // Real Footage click handler - navigate to last slide
            const realFootageLinks = document.querySelectorAll('a.real-footage');
            
            realFootageLinks.forEach(function(link) {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Find the product image slider
                    const sliderElement = document.querySelector('.product__image-slider');
                    
                    if (sliderElement) {
                        // Get Flickity instance
                        const flickityInstance = Flickity.data(sliderElement);
                        
                        if (flickityInstance) {
                            // Get the last slide index
                            const lastSlideIndex = flickityInstance.slides.length - 1;
                            // Navigate to last slide
                            flickityInstance.select(lastSlideIndex);
                        } else {
                            console.warn('Flickity instance not found on slider');
                        }
                    } else {
                        console.warn('Product image slider not found');
                    }
                });
            });
        });
